/**
 * Load the YouTube iFrame API asynchronously
 *
 * @since   1.0.0
 */
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var pausetimer = [];

/**
 * Initialize YouTube Videos
 *
 * Called by the YouTube iFrame API when it loads.
 *
 * @since   1.0.0
 */
var unc_youtube_players = [];
// console.log('hello video');


window.onYouTubeIframeAPIReady = function() {
    // console.log('hello video loaded');
    // Get jQuery
    var $ = jQuery.noConflict();

    // For each YouTube Video, initialize
    $( 'div.media.third-party > div.youtube' ).each( function( i, el ) {

        var $parent = $(el).parent().parent();
        // console.log(this);
        // Initialize, storing the player based on the iframe's ID.
        // As this will be unique, we can then support multiple players on the same screen.
        unc_youtube_players[ $( this ).attr( 'id' ) ] = new YT.Player( $( this ).attr( 'id' ), {
            width:  1200,
            height: 675,
            videoId:$( this ).data( 'video-id' ),
            playerVars: {
                autohide: 1,
                autoplay: 0,
                controls: 1,
                modestbranding: 1,
                rel : 0,
                showinfo: 0,
                widget_referrer: 'website'
            },
            events: {
              onReady: function() {
                  // Show Play Button
                  $( 'button.hosted.video.play', $( this ).attr( 'id' ) ).attr( 'aria-hidden', false ).addClass( 'show' );
              },
              onStateChange: function(event) {
                if(event.data == YT.PlayerState.ENDED) {
                  fadeInPoster(event);
                }
                if(event.data == YT.PlayerState.PAUSED) {
                  startPauseTimer();
                }
                if(event.data == YT.PlayerState.PLAYING) {
                  window.clearTimeout(pausetimer[$( this ).attr( 'id' )]);
                }
              }
            }
        });

        function startPauseTimer() {
          pausetimer[$( this ).attr( 'id' )] = window.setTimeout(fadeInPoster, 5000);
        }

        function fadeInPoster() {
          $parent.find('.column').removeClass('hide');
          $parent.find('.content').removeClass('hide');
          $parent.find('button.play').attr( 'aria-hidden', false ).addClass( 'show' );
          $parent.find('div.media').removeClass('full-width');
          $parent.find('div.poster-image').attr('aria-hidden', false).show();
        }

        function fadeOutPoster(event) {
          $parent.find('.column').addClass('hide');
          $parent.find('.content').addClass('hide');
          $parent.find('button.play').attr( 'aria-hidden', true ).addClass( 'hide' );
          $parent.find('div.media').addClass('full-width');
          $parent.find('div.poster-image').attr('aria-hidden', true).hide();
        }

    });
}


var initVideoControls = function( $ ) {
    //console.log('go for controls');
    /**
     * Ambient Video Autoplay Preference on load
     *
     * @since   1.0.0
     *
     * @TODO Move this to cookies, so that we can remove the 'autoplay' tag via Twig on render,
     * ensuring that videos don't start to autoplay and then stop because JS execution is delayed.
     */
    if ( localStorage.getItem( 'ambient_video' ) === 'paused' ) {
        // Pause each Ambient Video, as the user's preference is to do this
        $( '.video.ambient-video' ).each( function() {
            // Pause Video
            $( 'video' ).get( 0 ).pause();

            // Change Pause Button to Play
            $( 'button.pause', $( this ) ).addClass( 'paused' ).text( 'Play Video' );

        } );
    }

    /**
     * Ambient (Background) Video Controls
     *
     * @since   1.0.0
     */
    $( document ).on( 'click', '.video.ambient-video button.pause', function( e ) {

        // Prevent default action
        e.preventDefault();

        // Get Video
        var unc_video = $( 'video', $( this ).closest( 'div.ambient-video' ) );

        // Get Video State
        if ( $( this ).hasClass( 'paused' ) ) {
            // Video is Paused
            // Play it
            $( unc_video ).get( 0 ).play();

            // Change Play Button to Pause
            $( this ).removeClass( 'paused' ).text( 'Pause Video' );

            // Update User Preference for Ambient Video Autoplay on next page load
            localStorage.setItem( 'ambient_video', 'playing' );
        } else {
            // Video is Playing
            // Pause it
            $( unc_video ).get( 0 ).pause();

            // Change Pause Button to Play
            $( this ).addClass( 'paused' ).text( 'Play Video' );

            // Update User Preference for Ambient Video Autoplay on next page load
            localStorage.setItem( 'ambient_video', 'paused' );
        }

    } );

    /**
     * Video Controls
     *
     * @since   1.0.0
     */
    $( document ).on( 'click', '.video-controls .video', function( e ) {

        // Prevent default action
        e.preventDefault();

        // Determine whether we're displaying a self hosted video or YouTube Video
        var unc_video_type = ( $( 'video', $( this ).closest( 'div.media' ) ).length > 0 ? 'hosted' : 'youtube' );

        console.log( unc_video_type );

        // Get video
        switch ( unc_video_type ) {

            case 'hosted':
                var unc_video = $( 'video', $( this ).closest( 'div.media' ) );
                break;

            case 'youtube':
                var unc_video = unc_youtube_players[ $( 'iframe', $( this ).closest( 'div.media' ) ).attr( 'id' ) ];
                break;

        }

        // Depending on the button action, do something
        switch ( $( this ).data( 'action' ) ) {

            /**
             * Play
             */
            case 'play':
                // Set video to full width, if required and the viewport exceeds the minimum width
                if ( $( this ).closest( 'div.media' ).hasClass( 'full-width-on-play' ) && $( window ).width() >= $( this ).closest( 'div.media' ).data( 'min-viewport' ) ) {
                    $( this ).closest( 'div.media' ).addClass( 'full-width' );
                }

                // Add Hide class to content div
                $( '.content, .column', $( this ).closest( 'section' ) ).addClass( 'hide' );

                // Hide play control
                $( 'button.play', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', true ).removeClass( 'show' );

                // Show pause, volume and close controls
                $( 'button.pause', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', false ).addClass( 'show' );
                $( 'button.mute', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', false ).addClass( 'show' );
                $( 'button.close', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', false ).addClass( 'show' );

                // Play video
                switch ( unc_video_type ) {
                    case 'hosted':
                        // Play video
                        $( unc_video ).get( 0 ).play();

                        // when the self hosted video ends return to the poster state
                        $(unc_video).on('ended', function(){

                            if ( $( this ).closest( 'div.media' ).hasClass( 'full-width-on-play' ) && $( window ).width() >= $( this ).closest( 'div.media' ).data( 'min-viewport' ) ) {
                                $( this ).closest( 'div.media' ).removeClass( 'full-width' );
                            }

                            // Add Hide class to content div
                            $( '.content, .column', $( this ).closest( 'section' ) ).removeClass( 'hide' );

                            // Show play control
                            $( 'button.play', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', false ).addClass( 'show' );

                            // Show pause, volume and close controls
                            $( 'button.pause', $( this ).closest( 'div.media' )).attr( 'aria-hidden', true ).removeClass( 'show' );
                            $( 'button.resume', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', true ).removeClass( 'show' );
                            $( 'button.mute', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', true ).removeClass( 'show' );
                            $( 'button.unmute', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', true ).removeClass( 'show' );
                            $( 'button.close', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', true ).removeClass( 'show' );

                            // Hide cover image
                            $( 'div.poster-image', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', false ).show();
                        });
                        
                        break;

                    case 'youtube':
                        // Play video
                        unc_video.playVideo();
                        break;
                }

                // Hide cover image
                $( 'div.poster-image', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', true ).hide();

                // Set focus on Pause button
                $( 'button.pause', $( this ).parent() ).focus();

                break;

            /**
             * Pause
             */
            case 'pause':
                // Pause video
                switch ( unc_video_type ) {
                    case 'hosted':
                        $( unc_video ).get( 0 ).pause();
                        break;
                }

                // Hide pause control
                $( 'button.pause', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', true ).removeClass( 'show' );

                // Show resume control
                $( 'button.resume', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', false ).addClass( 'show' );
                break;

            /**
             * Resume
             */
            case 'resume':
                // Play video
                switch ( unc_video_type ) {
                    case 'hosted':
                        $( unc_video ).get( 0 ).play();
                        break;
                }

                // Hide resume control
                $( 'button.resume', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', true ).removeClass( 'show' );

                // Show pause control
                $( 'button.pause', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', false ).addClass( 'show' );
                break;

            /**
             * Mute
             */
            case 'mute':
                // Mute video
                switch ( unc_video_type ) {
                    case 'hosted':
                        $( unc_video ).prop( 'muted', true );
                        break;
                }

                // Hide mute control
                $( 'button.mute', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', true ).removeClass( 'show' );

                // Show unmute control
                $( 'button.unmute', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', false ).addClass( 'show' );
                break;

            /**
             * Unmute
             */
            case 'unmute':
                // Unmute video
                switch ( unc_video_type ) {
                    case 'hosted':
                        $( unc_video ).prop( 'muted', false );
                        break;
                }

                // Hide unmute control
                $( 'button.unmute', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', true ).removeClass( 'show' );

                // Show mute control
                $( 'button.mute', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', false ).addClass( 'show' );
                break;

            /**
             * Close
             */
            case 'close':
                // Stop video
                switch ( unc_video_type ) {
                    case 'hosted':
                        $( unc_video ).get( 0 ).pause();
                        break;
                }

                // Hide pause, resume, volume and close controls
                $( 'button.pause', $( this ).closest( 'div.media' )).attr( 'aria-hidden', true ).removeClass( 'show' );
                $( 'button.resume', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', true ).removeClass( 'show' );
                $( 'button.mute', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', true ).removeClass( 'show' );
                $( 'button.unmute', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', true ).removeClass( 'show' );
                $( 'button.close', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', true ).removeClass( 'show' );

                // Show play control
                $( 'button.play', $( this ).closest( 'div.media' ) ).attr( 'aria-hidden', false ).addClass( 'show' );

                // Remove full width class
                $( this ).closest( 'div.media' ).removeClass( 'full-width' );

                // Remove Hide class from content div
                $( '.content, .column', $( this ).closest( 'section' ) ).removeClass( 'hide' );

                // Reload and unmute video
                switch ( unc_video_type ) {
                    case 'hosted':
                        // Reload the video, so that the placeholder image displays
                        $( unc_video ).get( 0 ).load();

                        // Unmute the video in case it was closed when muted
                        $( unc_video ).prop( 'muted', false );
                        break;
                }
                break;
        }

    } );

};

(function ( $ ) {
    initVideoControls( $ )
})(jQuery)
